module.exports = __webpack_public_path__ + "static/img/ninja-can-38.ff1c8e3f.png";